if (!customElements.get('progress-bar')) {
  customElements.define(
    'progress-bar',
    class ProgressBar extends HTMLElement {
      constructor() {
        super();

        if (!this.elements.container) return;

        this.direction = this.dataset.direction || 'top';
        this.handleScrollPosition();
        this.setStartPosition();
        this.elements.container.addEventListener('scroll', this.handleScrollPosition.bind(this));

        this.elements.scrollTopTrigger?.addEventListener('click', this.handleScrollTop.bind(this));
      }

      handleScrollPosition() {
        if (!this.elements.container) return;

        const { scrollHeight, scrollWidth, scrollTop, scrollLeft, clientHeight, clientWidth } = this.elements.container;
        const scrollPercent =
          this.direction === 'top'
            ? (scrollTop / (scrollHeight - clientHeight)) * 100
            : (scrollLeft / (scrollWidth - clientWidth)) * 100;

        this.style.width = `${scrollPercent}%`;
      }

      handleScrollTop() {
        if (!this.elements.container) return;

        this.elements.container.scrollTo({
          top: 0,
          behavior: 'smooth',
        });
      }

      setStartPosition() {
        if (!this.elements.container || !this.elements.startPosition) return;

        this.elements.container.scrollTop = this.startPosition;
      }

      get elements() {
        return {
          container: document.querySelector(`[js-progress-bar="${this.dataset.key}"]`),
          /**
           * @type {HTMLElement | null}
           */
          startPosition: document.querySelector(`[js-progress-bar-start-position="${this.dataset.key}"]`),
          scrollTopTrigger: document.querySelector(`[js-progress-bar-scroll-top-trigger="${this.dataset.key}"]`),
        };
      }

      get startPosition() {
        if (!this.elements.startPosition) return 0;

        return this.elements?.startPosition?.offsetTop - this.headerHeightPx;
      }

      get headerHeightPx() {
        return parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--header-height')) * 16;
      }
    },
  );
}
